<form [formGroup]="expensecomplianceForm" (ngSubmit)="onSubmit()">
  <p-card>
    <div class="formgrid grid">
      <input type="hidden" formControlName="campaignId" />
      <input type="hidden" formControlName="expenseComplianceRequestId" />
      <div class="field col-12 md:col-3">
        <label for="expenseComplianceFundCodeDescription" class="field-label">Fund Code</label>
        <p class="field-label required">{{expensecomplianceForm.get('expenseComplianceFundCodeDescription')?.value}}</p>
        <input type="hidden" id="expenseComplianceFundCode" formControlName="expenseComplianceFundCode" />
        <input type="hidden" id="expenseComplianceFundCodeDescription" formControlName="expenseComplianceFundCodeDescription" />
      </div>
      <div class="field col-12 md:col-3">
        <label for="expenseComplianceFundElection" class="field-label">Election</label>
        <p class="field-label required">{{expensecomplianceForm.get('expenseComplianceFundElection')?.value}}</p>
        <input type="hidden" id="expenseComplianceFundElection" formControlName="expenseComplianceFundElection"/>
      </div>
      <div class="field col-12 md:col-3">
        <label for="expenseComplianceFundElectionYear"
          class="field-label">Election Year</label>
        <p class="field-label required">{{expensecomplianceForm.get('expenseComplianceFundElectionYear')?.value}}</p>
        <input type="hidden" id="expenseComplianceFundElectionYear" formControlName="expenseComplianceFundElectionYear"/>
      </div>
    </div>
  </p-card>

  <p-card>
    <div class="formgrid grid">
      <div class="field col-6">
        <label for="expenseComplianceLineNumber" class="field-label required">Line Number</label>
        <p-dropdown id="expenseComplianceLineNumber" formControlName="expenseComplianceLineNumber" [options]="lineNumbers" 
        optionLabel="text" optionValue="value" placeholder="Please Select" onchange="getLineNumber()"></p-dropdown>
        <small
          *ngIf="expensecomplianceForm.get('expenseComplianceLineNumber')?.invalid && expensecomplianceForm.get('expenseComplianceLineNumber')?.touched"
          class="error">
          Line Number is required.
        </small>
      </div>
      <div class="field col-6">
        <label for="expenseComplianceMemo" class="field-label">Memo</label>
        <p-toggleButton inputId="expenseComplianceMemo" formControlName="expenseComplianceMemo" onLabel="Yes"
          offLabel="No" [onIcon]="onIcon" offIcon="pi pi-ban" styleClass="w-6rem"></p-toggleButton>
      </div>
      <div class="formgrid grid align-items-end" *ngIf="showfederal">
        <div class="field col-12 md:col-3">
          <label for="federalShare">Federal Share</label>
          <input pInputText id="federalShare" type="number" formControlName="federalShare" readonly class="gray-input"/>
        </div>
        <div class="field col-12 md:col-1 text-center">
          <label>&nbsp;</label>
          <div class="p-mt-2">+</div>
        </div>
        <div class="field col-12 md:col-3">
          <label for="nonFederalShare">Non Federal Share</label>
          <input pInputText id="nonFederalShare" type="number" formControlName="nonFederalShare" readonly class="gray-input"/>
        </div>
        <div class="field col-12 md:col-1 text-center">
          <label>&nbsp;</label>
          <div class="p-mt-2">=</div>
        </div>
        <div class="field col-12 md:col-3">
          <label for="total">Total</label>
          <input pInputText id="total" type="number" formControlName="total" readonly class="gray-input"/>
        </div>
        <div class="field col-12 md:col-1 text-center">
          <label>&nbsp;</label>
          <i class="pi pi-check-circle" style="color: green; font-size: 1.5rem; margin-top: 1.5rem"></i>
        </div>
      </div>
    </div>
  </p-card>
  <p-card>
    <div class="formgrid grid">
      <div class="field col-12 md:col-6">
        <label for="expenseComplianceDescription" class="field-label">Description</label>
        <textarea id="expenseComplianceDescription" formControlName="expenseComplianceDescription" rows="4" cols="50" pInputTextarea
          style="resize: none;"></textarea>
      </div>
      <div class="field col-12 md:col-6">
        <label for="expenseComplianceMemoText" class="field-label">Memo Text</label>
        <textarea id="expenseComplianceMemoText" formControlName="expenseComplianceMemoText" rows="4" cols="50" pInputTextarea
          style="resize: none;"></textarea>
      </div>
    </div>
  </p-card>
  <p-card>
    <p-button [outlined]="true" severity="secondary" label="Previous" (onClick)="prevCallback.emit()" />
    <p-button type="submit" label="Next" severity="secondary" />
  </p-card>
</form>